'use client'
import {
  DecoratedSection_default
} from "./chunk-HJCFOVNG.mjs";
import {
  ContentfulMedia_default
} from "./chunk-BYRNGPWN.mjs";
import {
  useSections
} from "./chunk-VSTAKFRX.mjs";

// src/components/spotlight/SpotlightAsync.tsx
import { useRouter } from "@wbk/config";

// src/components/spotlight/SpotlightCarousel.tsx
import { Button, Carousel, Paper, Typography } from "@wbk/ui";
import { useAnalytics } from "@wbk/analytics";
import { Link } from "@wbk/config";
import { twMerge } from "tailwind-merge";
import { Fragment, jsx, jsxs } from "react/jsx-runtime";
var SpotlightCarousel = ({ section, className }) => {
  const cards = section.contentCollection.items;
  const { trackEvent } = useAnalytics();
  if (!cards.length) return null;
  return /* @__PURE__ */ jsx(
    DecoratedSection_default,
    {
      section,
      className: twMerge("container", className),
      "data-testid": `section_spotlight_carousel_${section.id}`,
      children: /* @__PURE__ */ jsx(
        Carousel,
        {
          className: "pb-14",
          dots: true,
          title: /* @__PURE__ */ jsxs(Fragment, { children: [
            section.title && /* @__PURE__ */ jsx(Typography, { as: "h2", variant: "heading-L", children: section.title }),
            section.subtitle && /* @__PURE__ */ jsx(Typography, { className: "mt-1", color: "text-secondary", children: section.subtitle })
          ] }),
          options: { active: cards.length > 1 },
          arrows: "top",
          arrowsClassName: "hidden md:flex",
          children: cards.map((card, i) => {
            var _a;
            return /* @__PURE__ */ jsx(
              "div",
              {
                "data-multiple": (cards == null ? void 0 : cards.length) > 1,
                className: "group relative me-4 flex w-full shrink-0 data-[multiple=true]:max-w-[95%] data-[multiple=true]:basis-[342px] data-[multiple=true]:md:basis-[648px]",
                children: /* @__PURE__ */ jsx(
                  Paper,
                  {
                    className: "!rounded-L mt-[25%] flex grow bg-[length:100%_112px] bg-top bg-no-repeat !p-0 text-center transition-transform md:mt-[15%] md:!bg-none",
                    style: {
                      backgroundImage: ((_a = card.background) == null ? void 0 : _a.url) ? `url(${card.background.url})` : "none"
                    },
                    children: /* @__PURE__ */ jsxs("div", { className: "-mt-[25%] flex grow flex-col items-center justify-between px-6 py-4 md:-mt-[15%] md:p-6", children: [
                      /* @__PURE__ */ jsxs("div", { className: "self-stretch", children: [
                        /* @__PURE__ */ jsx(
                          ContentfulMedia_default,
                          {
                            media: card.image31 || card.image,
                            className: "rounded-L aspect-1 md:aspect-3 md:border-paper relative hidden w-full md:block md:border",
                            placeholder: true
                          }
                        ),
                        /* @__PURE__ */ jsx(
                          ContentfulMedia_default,
                          {
                            media: card.image11 || card.image,
                            className: "rounded-L aspect-1 md:aspect-3 md:border-paper relative w-full md:hidden md:border",
                            placeholder: true
                          }
                        ),
                        /* @__PURE__ */ jsxs("div", { className: "my-4 space-y-1", children: [
                          /* @__PURE__ */ jsx(Typography, { as: "h3", variant: "heading-M", children: card.title }),
                          card.subtitle && /* @__PURE__ */ jsx(Typography, { variant: "body-S", children: card.subtitle })
                        ] })
                      ] }),
                      card.href && card.buttonLabel && /* @__PURE__ */ jsx(
                        Button,
                        {
                          as: Link,
                          href: card.href,
                          theme: "action",
                          "data-testid": "section_spotlight_button",
                          "aria-label": card.title ? `${card.buttonLabel} - ${card.title}` : void 0,
                          className: "w-full min-w-60 md:w-auto",
                          onClick: () => {
                            var _a2;
                            trackEvent({
                              event: "clicked_on_section_item",
                              data: {
                                type: card.__typename,
                                item_id: (_a2 = card.sys) == null ? void 0 : _a2.id,
                                slug: card.href,
                                label: card.title,
                                section: section.id,
                                position: i
                              }
                            });
                          },
                          children: /* @__PURE__ */ jsx(Typography, { strong: true, children: card.buttonLabel })
                        }
                      )
                    ] })
                  }
                )
              },
              card.id + i
            );
          })
        }
      )
    }
  );
};
var SpotlightCarousel_default = SpotlightCarousel;

// src/components/spotlight/SpotlightAsync.tsx
import { jsx as jsx2 } from "react/jsx-runtime";
var SpotlightSectionAsync = ({ id = "webook_event_spotlight_SA", className }) => {
  var _a;
  const { locale } = useRouter();
  const { data } = useSections({ limit: 1, lang: locale, where: { id } });
  const section = (_a = data == null ? void 0 : data.items) == null ? void 0 : _a[0];
  if (!section) return null;
  return /* @__PURE__ */ jsx2(SpotlightCarousel_default, { section, className });
};
var SpotlightAsync_default = SpotlightSectionAsync;

// src/components/spotlight/SpotlightGrid.tsx
import { Button as Button2, Paper as Paper2, Typography as Typography2 } from "@wbk/ui";
import { useAnalytics as useAnalytics2 } from "@wbk/analytics";
import { Link as Link2 } from "@wbk/config";
import { twMerge as twMerge2 } from "tailwind-merge";
import { jsx as jsx3, jsxs as jsxs2 } from "react/jsx-runtime";
var SpotlightGrid = ({ section, className }) => {
  const cards = section.contentCollection.items;
  const { trackEvent } = useAnalytics2();
  if (!cards.length) return null;
  return /* @__PURE__ */ jsxs2(
    DecoratedSection_default,
    {
      section,
      className: twMerge2("container", className),
      "data-testid": `section_spotlight_carousel_${section.id}`,
      children: [
        /* @__PURE__ */ jsxs2("div", { className: "space-y-S", children: [
          section.title && /* @__PURE__ */ jsx3(Typography2, { as: "h2", variant: "heading-L", children: section.title }),
          section.subtitle && /* @__PURE__ */ jsx3(Typography2, { className: "mt-1", color: "text-secondary", children: section.subtitle })
        ] }),
        /* @__PURE__ */ jsx3("div", { className: "gap-L grid grid-cols-1 sm:grid-cols-2", children: cards.map((card, i) => {
          var _a;
          return /* @__PURE__ */ jsx3("div", { className: "group flex w-full", children: /* @__PURE__ */ jsx3(
            Paper2,
            {
              className: "!rounded-M flex grow text-center transition-transform md:!bg-none",
              style: {
                backgroundImage: ((_a = card.background) == null ? void 0 : _a.url) ? `url(${card.background.url})` : "none"
              },
              children: /* @__PURE__ */ jsxs2("div", { className: "flex grow flex-col items-center justify-between", children: [
                /* @__PURE__ */ jsxs2("div", { className: "self-stretch", children: [
                  /* @__PURE__ */ jsx3(
                    ContentfulMedia_default,
                    {
                      media: card.image31 || card.image,
                      className: "rounded-M aspect-2 border-paper relative hidden w-full border object-cover md:block",
                      placeholder: true
                    }
                  ),
                  /* @__PURE__ */ jsx3(
                    ContentfulMedia_default,
                    {
                      media: card.image11 || card.image,
                      className: "rounded-M aspect-1 border-paper relative w-full border object-cover md:hidden",
                      placeholder: true
                    }
                  ),
                  /* @__PURE__ */ jsxs2("div", { className: "space-y-XS my-4", children: [
                    /* @__PURE__ */ jsx3(Typography2, { as: "h3", variant: "heading-S", children: card.title }),
                    card.subtitle && /* @__PURE__ */ jsx3(Typography2, { variant: "body-S", color: "text-secondary", children: card.subtitle })
                  ] })
                ] }),
                card.href && card.buttonLabel && /* @__PURE__ */ jsx3(
                  Button2,
                  {
                    as: Link2,
                    href: card.href,
                    theme: "action",
                    shape: "outlined",
                    "data-testid": "section_spotlight_button",
                    className: "my-S w-full min-w-60 md:w-auto",
                    onClick: () => {
                      var _a2;
                      trackEvent({
                        event: "clicked_on_section_item",
                        data: {
                          type: card.__typename,
                          item_id: (_a2 = card.sys) == null ? void 0 : _a2.id,
                          slug: card.href,
                          label: card.title,
                          section: section.id,
                          position: i
                        }
                      });
                    },
                    children: /* @__PURE__ */ jsx3(Typography2, { strong: true, children: card.buttonLabel })
                  }
                )
              ] })
            }
          ) }, card.id + i);
        }) })
      ]
    }
  );
};
var SpotlightGrid_default = SpotlightGrid;

export {
  SpotlightCarousel_default,
  SpotlightAsync_default,
  SpotlightGrid_default
};
//# sourceMappingURL=chunk-JMON7ZHP.mjs.map